import React, { useState } from 'react';
import ImageM from '../../assets/AI.png'; // Mission Image
import VisionImage from '../../assets/server4.jpg'; // Vision Image

const Mission = () => {
    const [activeTab, setActiveTab] = useState('vision');

    const handleTabClick = (tab) => {
        setActiveTab(tab);
    };

    return (
        <div className="flex flex-col items-center justify-center bg-gray-100 p-6">
            <div className="w-full max-w-4xl">
                {/* Vision and Mission Tabs */}
                <div className="flex flex-col sm:flex-row justify-center items-center mb-8 space-y-4 sm:space-y-0 sm:space-x-4">
                    <button
                        className={`flex justify-center items-center w-full sm:w-auto border-b-4 border-[#C5B358] px-10 sm:px-20 py-2 rounded-t-lg transform transition-all duration-300 ${
                            activeTab === 'vision'
                                ? 'bg-[#023B8D] text-[#C5B358]'
                                : 'text-blue-900 hover:bg-[#C5B358] hover:scale-105 hover:text-blue-800'
                        }`}
                        onClick={() => handleTabClick('vision')}
                    >
                        OUR VISION
                    </button>
                    <button
                        className={`flex justify-center items-center w-full sm:w-auto border-b-4 border-[#C5B358] px-10 sm:px-20 py-2 rounded-t-lg transform transition-all duration-300 ${
                            activeTab === 'mission'
                                ? 'bg-[#023B8D] text-[#C5B358]'
                                : 'text-blue-900 hover:bg-[#C5B358] hover:scale-105 hover:text-blue-800'
                        }`}
                        onClick={() => handleTabClick('mission')}
                    >
                        OUR MISSION
                    </button>
                </div>
                <div className="relative flex flex-col lg:flex-row items-center p-4 sm:p-8 transition-all duration-500 ease-in-out transform">
            {/* Vision Text */}
            <div className="relative flex flex-col items-center p-6 transition-all duration-500 ease-in-out transform w-full sm:w-2/3 md:w-1/2">
            {/* Vision Text */}
                <div
                    className={`mb-6 text-center transition-all duration-500 ease-in-out transform ${
                        activeTab === 'vision'
                            ? 'opacity-100 translate-x-0'
                            : 'opacity-0 -translate-x-10 absolute'
                    }`}
                >
                    <p className="text-xl sm:text-xl text-gray-700">
                        Our vision is to lead the industry in providing innovative and sustainable ICT solutions that empower businesses worldwide.
                    </p>
                </div>

                {/* Mission Text */}
                <div
                    className={`mb-6 text-center transition-all duration-500 ease-in-out transform ${
                        activeTab === 'mission'
                            ? 'opacity-100 translate-x-0'
                            : 'opacity-0 translate-x-10 absolute'
                    }`}
                >
                    <p className="text-xl sm:text-xl text-gray-700">
                        Continuously innovate and deploy ICT infrastructure services to ensure customers effectively cost setup, operate, and expand their reach.
                    </p>
                </div>
            </div>

            {/* Vision Image */}
            <div
                className={`lg:w-1/3 flex justify-center transition-all duration-500 ease-in-out transform ${
                    activeTab === 'vision'
                        ? 'opacity-100 translate-y-0'
                        : 'opacity-0 translate-y-10 absolute'
                }`}
            >
                <img
                    src={VisionImage}
                    alt="Vision"
                    className="w-full max-w-xs sm:max-w-sm md:max-w-md rounded-lg shadow-md"
                    style={{ height: '300px', objectFit: 'cover' }}
                />
            </div>

            {/* Mission Image */}
            <div
                className={`lg:w-1/3 flex justify-center transition-all duration-500 ease-in-out transform ${
                    activeTab === 'mission'
                        ? 'opacity-100 translate-y-0'
                        : 'opacity-0 -translate-y-10 absolute'
                }`}
            >
                <img
                    src={ImageM}
                    alt="Mission"
                    className="w-full max-w-xs sm:max-w-sm md:max-w-md rounded-lg shadow-md"
                    style={{ height: '300px', objectFit: 'cover' }}
                />
            </div>
        </div>

            </div>
        </div>
    );
};

export default Mission;
